export const unsetUser = () => ({ type: 'UNSET_USER' });
export const setUser = (values) => ({ type: 'SET_USER', user: values });
export const setNotification = (values) => ({ type: 'SET_NOTIFICATION', summ: values });
export const setOrder = (order) => ({ type: 'SET_ORDER', order: order });
export const checkUser = (loginedInfo) => ({ type: 'USER_CHECKED', value: true, result: loginedInfo });
export const setDictionaries = (data) => ({ type: 'SET_DICTIONARIES', value: data });
export const setClient = (data) => ({ type: 'SET_CLIENT', value: data });
export const setChangePassword = (data) => ({ type: 'SET_CHANGE_PASSWORD', value: data });
